// TODO: delete this component when useImprovedBrandFiltering FF removed
import { connect } from '../../../stores'
import { selectPaidAdCampaigns } from '../../../stores/content/selectors'

import LegacyPaidAdCampaigns from './LegacyPaidAdCampaigns'

const mapStateToProps = (state) => ({
  ...selectPaidAdCampaigns(state),
})

export default connect(mapStateToProps)(LegacyPaidAdCampaigns)
